// Mock data for EBC Website

export const companyInfo = {
  name: "شركة التوازن البيئي",
  nameEn: "Environmental Balance Company",
  abbreviation: "EBC",
  logo: "https://customer-assets.emergentagent.com/job_ebc-depths/artifacts/5ly1yzdt_Logo.png",
  tagline: "شركة استشارات بيئية رائدة في المملكة العربية السعودية",
  foundedYear: 2011
};

export const heroContent = {
  title: "شركة التوازن البيئي",
  subtitle: "شركة استشارات بيئية رائدة في المملكة العربية السعودية",
  ctaText: "تعرف علينا",
  backgroundImages: {
    light: [
      "https://images.unsplash.com/photo-1775868788732-1229aecc5fac",
      "https://images.unsplash.com/photo-1775868786869-9f82b6fc5df6",
      "https://images.unsplash.com/photo-1775868786913-e74138922619"
    ],
    dark: [
      "https://images.unsplash.com/photo-1601301560274-080223bb298b",
      "https://images.unsplash.com/photo-1768851719323-61ab229fb60e"
    ]
  }
};

export const aboutContent = {
  title: "عن شركة التوازن البيئي",
  titleEn: "About Al-Tawazun Al-Bee'ie Company",
  content: "تُعد شركة التوازن البيئي منشأة استشارية رائدة في القطاع البيئي بالمملكة العربية السعودية، حيث نفخر بحصولنا على التصنيف (أ) من المركز الوطني للامتثال البيئي، وانطلاقاً من مقرنا الرئيسي في مدينة جدة، نلتزم بتقديم حلول بيئية مبتكرة تستند إلى المعرفة العلمية العميقة والمسؤولية الأخلاقية تجاه كوكبنا.\n\nنرتكز على نخبة من الخبراء والعلماء المؤهلين تأهيلاً عالياً في مختلف التخصصات البيئية (البحرية والبرية). يمتلك فريقنا الأساسي إرثاً يمتد لعدة عقود من العمل الميداني والاستراتيجي في المملكة العربية السعودية ودول الخليج العربي، منطقة البحر الأحمر والشرق الأوسط، والدول المجاورة.\n\nنعتمد نموذج عمل مرن يربطنا بشبكة عالمية من العلماء المتميزين؛ مما يتيح لنا تشكيل فرق عمل متخصصة لكل مشروع بدقة متناهية، حيث ندعم هذه الخبرات بـأحدث التقنيات والمعدات العلمية المتطورة وفهم عميق بالإجراءات الحكومية ومعايير القطاع الخاص واعتماد التراخيص التي تضمن أعلى مستويات الجودة والامتثال.\n\nلا يقتصر دورنا في شركة التوازن البيئي على الاستشارات الفنية، بل نمتد لنكون شريكاً فاعلاً في بناء المستقبل من خلال:\n\n• البحث والتطوير: نشر المقالات العلمية في المجلات البحثية المرموقة.\n\n• التوعية والتدريب: برامج متخصصة لرفع الكفاءات الوطنية ونشر الثقافة البيئية.\n\n• الدعم الاستشاري الفني: دور ريادي كجهة مانحة للمؤسسات التعليمية والمنظمات غير الحكومية.",
  contentEn: "Al-Tawazun Al-Bee'ie (Ecological Balance) Company is a leading consultancy firm in the environmental sector in the Kingdom of Saudi Arabia. We are proud to hold a Class (A) classification from the National Center for Environmental Compliance (NCEC). Based at our headquarters in Jeddah, we are committed to providing innovative environmental solutions grounded in deep scientific knowledge and ethical responsibility toward our planet.\n\nWe rely on an elite group of highly qualified experts and scientists across various environmental disciplines (marine and terrestrial). Our core team possesses a legacy spanning several decades of field and strategic work within the Kingdom of Saudi Arabia, the Arabian Gulf states, the Red Sea region, the Middle East, and neighboring countries.\n\nWe adopt a flexible business model that connects us with a global network of distinguished scientists. This enables us to assemble specialized task forces for each project with utmost precision. We support this expertise with the latest technologies, advanced scientific equipment, a deep understanding of government procedures, private sector standards, and license accreditations that guarantee the highest levels of quality and compliance.\n\nAt Al-Tawazun Al-Bee'ie Company, our role is not limited to technical consultations; rather, we extend to being an active partner in building the future through:\n\n• Research and Development: Publishing scientific articles in prestigious research journals.\n\n• Awareness and Training: Specialized programs to enhance national capabilities and promote environmental culture.\n\n• Technical Advisory Support: A leading role in supporting and empowering educational institutions and non-governmental organizations (NGOs)."
};

export const visionContent = {
  title: "رؤيتنا",
  titleEn: "Vision",
  content: "الريادة في مجال الاستشارات البيئية بما يحقق الاستدامة البيئية و رؤية المملكة 2030.",
  contentEn: "Leadership in the environmental consultancy field to achieve environmental sustainability and Saudi Vision 2030."
};

export const missionContent = {
  title: "رسالتنا",
  titleEn: "Mission",
  content: "أن نكون شريكًا فاعلًا في صون البيئة وتعزيز مسارات التنمية للمملكة، وتقديم خدمات واستشارات بيئية احترافية تلتزم بالمعايير الوطنية والدولية، وتُسهم في تمكين المشروعات التنموية من تحقيق أهدافها البيئية والتنظيمية، والمشاركة في إتاحة وإنتاج المعرفة في كافة المجالات البيئية.",
  contentEn: "To be an active partner in environmental preservation and promoting development pathways for the Kingdom; to provide professional environmental services and consultations that adhere to national and international standards; to contribute to empowering development projects to achieve their environmental and regulatory goals; and to participate in generating and sharing knowledge across all environmental fields."
};

export const studiesData = [
  {
    id: 1,
    title: "التقييم والمراقبة",
    titleEn: "Assessment & Monitoring",
    description: "تقييم البيانات المختلفة ومراقبة تأثرها بالعوامل البيئية والبشرية المختلفة.",
    descriptionEn: "Evaluate different datasets and monitor how they are affected by environmental and human factors.",
    shellImage: "https://customer-assets-7cd3h4nn.emergentagent.net/job_ebc-depths/artifacts/88vnav0r_Environmental%20monitoring%20ebc.png"
  },
  {
    id: 2,
    title: "الاستشعار عن بعد ونظم المعلومات الجغرافية",
    titleEn: "Remote Sensing and Geographic Information Systems",
    description: "تحليل صور الأقمار الصناعية بما يخدم المشروعات البيئية وربطها بنظم المعلومات الجغرافية لتدير وتحلل وتخطط جميع أنواع البيانات الجغرافية والبيئية.",
    descriptionEn: "Analyzing satellite imagery to support environmental projects and integrating it with geographic information systems to manage, analyze, and plan all types of geographic and environmental data.",
    shellImage: "https://images.unsplash.com/photo-1524661135-423995f22d0b?w=1200&q=80"
  },
  {
    id: 3,
    title: "الدراسات البيئية",
    titleEn: "Environmental Studies",
    description: "تقديم خدمات متخصصة في مجال التقييم البيئي، مثل تقييم الأثر البيئي والحصول على التصاريح البيئية اللازمة.",
    descriptionEn: "Providing specialized environmental assessment services, including environmental impact assessments and obtaining the required environmental permits.",
    shellImage: "https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?w=1200&q=80"
  },
  {
    id: 4,
    title: "الدراسات البحرية",
    titleEn: "Marine Studies",
    description: "دراسة الآثار البيئية على البيئة البحرية للمرافق الساحلية الحكومية والخاصة باستخدام منهجية معترف بها دوليًا.",
    shellImage: "https://images.unsplash.com/photo-1582967788606-a171c1080cb0?w=1200&q=80"
  },
  {
    id: 5,
    title: "الاستشارات البيئية",
    titleEn: "Environmental Consultants",
    description: "خبرة واسعة في إجراء الدراسات البيئية والمسوحات البيئية لمجموعة متنوعة من مشاريع التنمية في المملكة.",
    shellImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80"
  }
];

export const galleryImages = [
  { id: 1, url: "https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?w=1200&q=80", title: "الصحراء العربية" },
  { id: 2, url: "https://images.unsplash.com/photo-1448375240586-882707db888b?w=1200&q=80", title: "الغابات الطبيعية" },
  { id: 3, url: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1200&q=80", title: "المرتفعات الجبلية" },
  { id: 4, url: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80", title: "أنظمة الزراعة المستدامة" },
  { id: 5, url: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1200&q=80", title: "الطاقة المتجددة" },
  { id: 6, url: "https://images.unsplash.com/photo-1546026423-cc4642628d2b?w=1200&q=80", title: "الشعاب المرجانية" }
];

export const diverImages = [
  "https://images.unsplash.com/photo-1544551763-46a013bb70d5",
  "https://images.unsplash.com/photo-1588732722208-4b86b49699a6"
];

export const statsData = [
  { id: 1, number: 320, suffix: "+", label: "عميل", labelEn: "Clients" },
  { id: 2, number: 2011, prefix: "منذ ", prefixEn: "Since ", label: "", labelEn: "" },
  { id: 3, number: 100, suffix: "%", label: "التزام", labelEn: "Environmental Compliance" }
];
